<app-sidebar-wrapper *transloco="let t"
                     [sidebarContent]="sidebarContent"
                     [sidebarTitle]="t('Switch Country')"
                     [primaryButtonLabel]="t('Switch')"
                     [secondaryButtonLabel]="t('Cancel')"
                     [isSidebarOpen]="sidebarDisplayStore.countrySwitchSidebarDisplayed()"
                     (primaryButtonClicked)="onActionButtonClicked()"
                     (sidebarClose)="closeSidebar()"
  data-cy="country-switch-sidebar-app-sidebar-wrapper">
  <ng-template #sidebarContent>
    <app-switch-country-sidebar-content
      class="w-100"
      [primaryActionClicked]="primaryActionClicked$"/>
  </ng-template>
</app-sidebar-wrapper>
